<template>
  <div :class="$style['pt-add-customer-form']">
    <pt-sub-title title="客户信息"></pt-sub-title>
    <pt-form-item label="客户名称：" :labelWidth="labelWidth" :required="true">
        <el-input name="base.name" data-vv-as="客户名称" v-validate="'required'" v-model="vendorData.base.name" placeholder="请填写客户名称"></el-input>
      </pt-form-item>
    <pt-form-item label="联系人：" :labelWidth="labelWidth" :required="true">
      <el-input name="base.contact" data-vv-as="联系人" v-validate="'required'" v-model="vendorData.base.contact" placeholder="请填写联系人姓名"></el-input>
    </pt-form-item>
    <pt-form-item label="手机号：" :labelWidth="labelWidth" :required="true">
      <el-input name="base.mobile" data-vv-as="手机号" v-validate="'required'" v-model="vendorData.base.mobile" placeholder="请填写手机号"></el-input>
    </pt-form-item>
      <pt-form-item label="身份证号：" :labelWidth="labelWidth">
        <el-input name="base.cardId" data-vv-as="身份证号" v-validate="'idCard'" v-model="vendorData.base.cardId" placeholder="请填写身份证号"></el-input>
      </pt-form-item>
    <pt-form-item label="邮箱：" :labelWidth="labelWidth">
      <el-input name="base.email" v-model="vendorData.base.email" placeholder="请填写邮箱"></el-input>
    </pt-form-item>
    <pt-form-item label="通讯地址：" :labelWidth="labelWidth" :required="true">
      <el-input name="base.address" data-vv-as="通讯地址" v-validate="'required'" v-model="vendorData.base.address" placeholder="请填写通讯地址"></el-input>
    </pt-form-item>
    <pt-sub-title title="客户企业信息"></pt-sub-title>
    <pt-form-item label="社会统一信用代码：" :labelWidth="labelWidth" :required="true">
        <el-input name="base.secCode" data-vv-as="社会统一信用代码" v-validate="'required'" v-model="vendorData.base.secCode" placeholder="请填写社会统一信用代码"></el-input>
      </pt-form-item>
      <pt-form-item label="企业执照副本：" :labelWidth="labelWidth">
        <!-- <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" listType="text"
          v-model="vendorData.base.licenses" :class="$style['dialog-upload']">
          <el-button size="small" type="primary">点击上传</el-button>
        </wt-upload-file> -->
        <wt-upload-big-file v-model="vendorData.base.licenses" @getStatus="getStatus"></wt-upload-big-file>
      </pt-form-item>
    <pt-form-item label="其他资质证照：" :labelWidth="labelWidth">
        <wt-upload-file :action="uploadApi" :data="picture_params" path-url-name="url" :img-url="privateResourcesUrl"
          v-model="vendorData.base.qualifications" :multiple="true" :class="$style['upload-picture']">
            <div :class="$style['upload-file-text']" class="main-color" @click.stop.prevent="showDialog = true">+添加图片</div>
        </wt-upload-file>
        <ul :class="$style.pictureNames">
          <li v-for="(item,index) in vendorData.base.qualifications" :key="index">{{item.name}}</li>
        </ul>
        <div :class="$style['upload-tips-text']"  class="gray-color">* 建议分辨率：120dpi，图片格式：.jpg、.png，可上传多张图片；</div>
      </pt-form-item>
      <pt-form-item label="代售合同：" :labelWidth="labelWidth">
        <!-- <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" listType="text"
          v-model="vendorData.base.contracts" :class="$style['dialog-upload']">
          <el-button size="small" type="primary">点击上传</el-button>
        </wt-upload-file> -->
        <wt-upload-big-file v-model="vendorData.base.contracts"  @getStatus="getStatus"></wt-upload-big-file>
      </pt-form-item>
      <pt-sub-title title="客户开票信息"></pt-sub-title>
      <pt-form-item label="开票类型：" :labelWidth="labelWidth" :required="true">
        <el-radio-group name="invoice.type" data-vv-as="开票类型" v-validate="'required'" v-model="vendorData.invoice.type">
          <el-radio label="ORDINARY_VAT">增值税普通发票</el-radio>
          <el-radio label="SPECIAL_VAT">增值税专用发票</el-radio>
        </el-radio-group>
      </pt-form-item>
      <!-- <pt-form-item label="可开具发票类型：" :labelWidth="labelWidth" :required="true">
        <el-checkbox-group name="invoice.ableType" data-vv-as="开具发票类型" v-validate="'required'" v-model="vendorData.invoice.ableType">
          <el-checkbox label="ELECTRONIC_VAT">电子发票</el-checkbox>
          <el-checkbox label="PAPER_VAT">纸质发票</el-checkbox>
        </el-checkbox-group>
      </pt-form-item> -->
      <pt-form-item label="发票抬头：" :labelWidth="labelWidth" :required="true">
        <el-input name="invoice.title" data-vv-as="发票抬头" v-validate="'required'" v-model="vendorData.invoice.title" placeholder="请填写发票抬头"></el-input>
      </pt-form-item>
      <pt-form-item label="纳税人识别号：" :labelWidth="labelWidth" :required="true">
        <el-input name="invoice.taxId" data-vv-as="纳税人识别号" v-validate="'required'" v-model="vendorData.invoice.taxId" placeholder="请填写纳税人识别号"></el-input>
      </pt-form-item>
      <pt-form-item label="公司地址：" :labelWidth="labelWidth">
        <el-input v-model="vendorData.invoice.companyAddress" placeholder="请填写公司地址"></el-input>
      </pt-form-item>
      <pt-form-item label="公司电话：" :labelWidth="labelWidth">
        <el-input v-model="vendorData.invoice.companyTel" placeholder="请填写公司电话"></el-input>
      </pt-form-item>
      <pt-form-item label="开户银行：" :labelWidth="labelWidth" >
        <el-input v-model="vendorData.invoice.depositBank" placeholder="请填写开户银行"></el-input>
      </pt-form-item>
      <pt-form-item label="银行账户：" :labelWidth="labelWidth">
        <el-input v-model="vendorData.invoice.depositBankAccount" placeholder="请填写银行账户"></el-input>
      </pt-form-item>
      <picture-dialog :showDialog="showDialog" @getFile="getFile" @updateVisible="updateVisible" :uploadApi="uploadApi" :picture-params="picture_params"></picture-dialog>
  </div>
</template>

<script>
import pictureDialog from './picture-dialog'
import formMixins from 'mixins/form'
import organizationRoleSelector from './organization-role-selector'
// import ptAddressSelect from 'cps/base/pt-address-select/withData'
import {
  vendorsType
} from 'json/mall-options'
import wtUploadBigFile from 'cps/common/wt-upload-big-file'
// import vendorTypeSelector from './vendor-type-selector'
// 组件class前缀
const prefixCls = 'pt-add-customer-form'

export default {
  name: 'pt-add-customer-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    vendorsTypes () {
      return vendorsType
    },
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    },
    tenant () {
      return this.$store.state.saasConfig.tenant
    }
  },
  props: {
    value: {
      type: Object,
      default: () => { }
    },
    rolesList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  components: {
    organizationRoleSelector,
    wtUploadBigFile,
    pictureDialog
  },
  data () {
    return {
      vendorData: this.value ? this.value : {
        // 基本信息
        base: {
          qualifications: [],
          contracts: [],
          licenses: []
        },
        // 发票
        invoice: {
          type: 'SPECIAL_VAT'
        }
      },
      labelWidth: '150px',
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'organization'
      },
      privateResourcesUrl: this.$privateResourcesUrl,
      showDialog: false
    }
  },
  watch: {
    vendorData: {
      handler (val) {
        console.log('===val',val)
        this.$emit('input', val)
      },
      deep: true
    },
    value (val) {
      this.vendorData = val
    }
  },
  methods: {
    updateVisible (val) {
      this.showDialog = val
    },
    getFile (val) {
      console.log('val', val)
      this.vendorData.base.qualifications.push(val)
    },
    getStatus (val) {
      this.$emit('isUpload', val)
    }
  }
}

</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-add-customer-form {
  .tip {
    color: red;
    line-height: 26px;
    margin: 0;
    font-size: 12px;
  }

  :global {
    .wt-address-select .province-district .area-detail {
      height: 60px;
    }

    .el-input,
    .el-input__inner {
      max-width: 2.8rem;
    }

    .el-input--suffix .el-input__inner {
      min-width: 2.8rem;
    }

    .el-upload--picture-card,
    .el-upload-list--picture-card .el-upload-list__item {
      width: 204px;
      height: 128px;
    }

    el-textarea,
    .el-textarea__inner {
      width: 500px;
      font-family: "Microsoft YaHei", "微软雅黑", "Avenir", Helvetica, Arial;
    }

    .wt-upload-file {
      line-height: 0;
      margin-top: 10px;
    }

    .el-upload-list {
      max-width: 800px;
    }
  }

  .pictureNames {
    display: flex;
    margin: 0;
    padding-left: 0;

    li {
      width: 204px;
      line-height: 20px;
      text-align: center;
    }
  }

  .upload-file-text {
    line-height: 128px;
  }
}

.package-table-div {
  margin-top: 10px;
  padding: 10px 20px 30px;
  max-width: 18rem;
}

.package-table {
  display: table !important;
  width: 100%;
  border-collapse: collapse !important;

  th,
  tr {
    width: 100% !important;
    max-width: 100% !important;
    display: table-row;
    padding: 0 !important;
    list-style-type: none;
    border-bottom: 1px solid #c6c9d3;
    color: #818181;
  }

  td {
    text-align: center;
  }
}
</style>
